function createDummyFacetGroup(selectedFacet) {
	return {
		dictionaryTerm: null,
		groupName: selectedFacet.groupName,
		id: '',
		isCollapsed: true,
		resultValues: [Object.assign(selectedFacet, { selected: true })],
		selected: true,
		selectedFacetQueries: [],
		selectedValues: selectedFacet.value,

		isRanged: false,
		min: 0,
		max: 0,
		mean: 0,
		stddev: 0,
		sum: 0
	};
}

/**
 * @function mergeSelectedFacets this function exists in case we have selected facets come back in the URL but not from Services.
 */
function mergeSelectedFacets(response) {
	if (!response) {
		return;
	}
	const returnedFacets = response.facets,
		selectedFacets = response.selectedFacets;
	if (!selectedFacets) {
		return;
	}
	selectedFacets.forEach((selectedFacet) => {
		let groupFound = false;
		returnedFacets.forEach((facetGroup) => {
			if (facetGroup.groupName === selectedFacet.groupName) {
				groupFound = true;

				// insert or ignore, group exists in both
				if (!facetGroup.selectedValues.includes(selectedFacet.value)) {
					let facetQuery = '';
					// we want to prepend an f to the facetId so that queryParams can be matched with selectedFacets when not using GBI data
					if (typeof selectedFacet.facetId === 'number') {
						facetQuery = 'f';
					}
					facetQuery = `${facetQuery}${selectedFacet.facetId}=${encodeURIComponent(selectedFacet.value)}`;
					if (facetGroup.selectedValues) {
						facetGroup.selectedValues = `${facetGroup.selectedValues}, ${selectedFacet.value}`;
					} else {
						facetGroup.selectedValues = selectedFacet.value;
					}
					facetGroup.selectedFacetQueries.push(facetQuery);
					facetGroup.resultValues.push(
						Object.assign(selectedFacet, {
							selected: true,
							facetQuery: facetQuery
						})
					);
					facetGroup.selectedCount = facetGroup.selectedCount + 1;
					facetGroup.selected = true;
				}
			}
		});
		// if no group is found for selected facet, create a dummy group, and insert it there.
		if (!groupFound) {
			returnedFacets.push(createDummyFacetGroup(selectedFacet));
		}
	});
}

module.exports = {
	mergeSelectedFacets
};
